<template>
  <div>
    <v-hover v-slot="{ hover }">
      <v-row
        align="center"
        no-gutters
        class="py-3"
        :class="hover ? 'green lighten-5' : ''"
      >
        <v-col cols="2" class="pl-2"
          ><v-avatar size="30" class="mr-4">
            <v-icon>mdi-truck</v-icon>
          </v-avatar>
          <b>{{ automezzo.nome }}</b>
        </v-col>

        <v-col cols="1">
          {{ automezzo.targa }}
        </v-col>
        <v-col cols="1">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="blue"> {{ signal_icon }}</v-icon>
            </template>
            <span>Potenza segnale: {{ automezzo.signal }}</span>
          </v-tooltip>
        </v-col>
        <v-col cols="3">
          <MappaGps :id_mezzo="automezzo.id" />
          <template v-if="status">
            <v-icon class="mr-2 ml-2" color="green"> mdi-link </v-icon>
            <span class="green--text">Online</span>
          </template>
          <template v-else>
            <v-icon class="mr-2 ml-2" color="red"> mdi-link-off </v-icon>
            <span class="red--text">Offline</span>
          </template>
          <template v-if="!automezzo.gps_status && status">
            <v-icon class="ml-2 mr-2" color="red">
              mdi-map-marker-off-outline
            </v-icon>
            <span class="red--text">Position No Fix</span>
          </template>
          <template v-else-if="automezzo.gps_status && status">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="green" class="ml-2"
                  >mdi-map-marker</v-icon
                >
              </template>
              <span
                ><v-icon color="white" size="18" class="mr-1"
                  >mdi-satellite-variant</v-icon
                >
                Satelliti: {{ automezzo.satellites }}</span
              >
            </v-tooltip>
            <span class="green--text">Position Fixed</span>
          </template>
        </v-col>
        <v-col cols="2">
          {{ last_update }}
        </v-col>
        <v-col cols="2"> {{ last_reboot }} ({{ reboot_ago }}) </v-col>
        <v-col cols="1">
          <v-dialog v-model="editDialog" width="400">
            <template v-slot:activator="{ on }">
              <v-btn icon small v-on="on" v-show="hover" color="blue">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title> Modifica Automezzo </v-card-title>
              <v-card-text>
                <v-row no-gutters>
                  <v-text-field
                    outlined
                    label="In Base Delay"
                    v-model="inbase_dalay"
                    prepend-inner-icon="mdi-clock"
                    suffix="sec"
                  />
                  <v-text-field
                    outlined
                    label="Out Base Delay"
                    v-model="outbase_delay"
                    prepend-inner-icon="mdi-clock"
                    suffix="sec"
                  />
                  <v-text-field
                    outlined
                    label="Distance Threshold"
                    v-model="distance_threshold"
                    prepend-inner-icon="mdi-map-marker-distance"
                    suffix="km"
                  />
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn color="blue" outlined :loading="loading_reset_gps" @click="forza_reset_gps">
                      <v-icon left>mdi-refresh</v-icon> Forza Reset GPS
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="grey" @click="editDialog = false">
                  Annulla
                </v-btn>
                <v-btn outlined color="blue" @click="salvaDelay"> Salva </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog" width="400">
            <template v-slot:activator="{ on }">
              <v-btn icon small v-on="on" v-show="hover" color="red">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="red--text"> Sei sicuro ? </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="grey" @click="dialog = false">
                  Annulla
                </v-btn>
                <v-btn outlined color="red" @click="elimina"> Elimina </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-hover>
    <v-divider />
  </div>
</template>

<script>
import MappaGps from "./mappa_gps.vue";
import auto_element_mixin from "../Mixin/automezzo_element_mixin";
export default {
  components: {
    MappaGps,
  },
  mixins: [auto_element_mixin],
  methods: {
    elimina() {
      this.$store.dispatch("elimina_automezzo", this.automezzo.id);
    },
    salvaDelay() {
      this.$store.dispatch("cambia_delay_gps", {
        id_mezzo: this.automezzo.id,
        inbase_delay: this.inbase_dalay * 1000,
        outbase_delay: this.outbase_delay * 1000,
        distance_threshold: this.distance_threshold,
      });
      this.editDialog = false;
    },
    forza_reset_gps() {
      this.loading_reset_gps = true;
      this.$store.dispatch("forza_reset_gps", {id_mezzo: this.automezzo.id}).then(() => {
        this.loading_reset_gps = false;
      });
    },
  },
};
</script>